import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!url || !anonKey) {
  throw new Error('VITE_SUPABASE_URL y VITE_SUPABASE_ANON_KEY son requeridos en .env');
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    // Implicit flow: permite verifyOtp con 6 digitos sin PKCE code verifier.
    // Con PKCE (default), cada llamada a resetPasswordForEmail genera un nuevo
    // verifier que pisa el anterior, rompiendo el verify si el usuario reenvía.
    // TODO Fase 11: evaluar PKCE cuando haya SMTP real y flujo de magic link.
    flowType: 'implicit',
  },
});
